import styled from "styled-components";
import bgStore from "../images/bg-store.svg";

const PageContainer = styled.div`
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  @media (max-width: 880px) {
    flex-direction: column;
  }
`;

const Logo = styled.div`
  img {
    height: 26px;
    margin-bottom: 66px;
  }
`;

const Content = styled.div`
  padding: 40px 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 55%;

  @media (max-width: 880px) {
    width: 100%;
  }

  .StoreBuilder__button-primary {
    margin-top: 24px;
  }

  .StoreBuilder__button-text {
    margin-top: 16px;
  }
`;

const Title = styled.div`
  font-size: 60px;
  font-weight: bold;
  line-height: 1.2;
  color: #000000;
  margin-bottom: 32px;

  span {
    color: #8144e5;
  }
`;

const List = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 22px;
  font-weight: bold;
  line-height: 1.82;
  color: #2e3039;

  img {
    height: 16px;
    margin-right: 16px;
  }
`;

const Footer = styled.div`
  background-color: #f6f5ff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45%;
  position: relative;

  @media (max-width: 880px) {
    width: 100%;
    &:before {
      display: none;
    }
  }

  &:before {
    content: "";
    height: 100%;
    top: 0;
    width: 50px;
    position: absolute;
    background-image: url(${bgStore});
    left: -50px;
    background-repeat: no-repeat;
    background-position: left;
  }

  img {
    width: 57%;
  }
`;

export { PageContainer, Content, Footer, Title, List, Logo };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/StoreBuilderStyle.js